import configJson from './publish.config.json';

type Env = 'dev' | 'prod';

export interface AppConfig {
  VITE_WEAVE_OKTA_CLIENT_ID: string;
  VITE_WEAVE_OKTA_ISSUER: string;
  VITE_WEAVE_APP_SOURCE: string;
  VITE_WEAVE_API: string;
}

export interface EnvConfig {
  displayName: string;
  slug: string;
  sites: { host: string; env: Env }[];
  env: {
    dev: AppConfig;
    prod: AppConfig;
  };
}

const envConfig = configJson as EnvConfig;

export const appConfig: AppConfig = (() => {
  let env: Env;

  if (
    import.meta.env.MODE === 'development' ||
    import.meta.env.MODE === 'dev' ||
    window.location.hostname.includes('dev.f.weavedev') ||
    window.location.hostname === 'integration-dashboard.weavedev.net'
  ) {
    env = 'dev';
  } else {
    env = 'prod';
  }

  return envConfig.env[env];
})();
